import React, { useState } from 'react';

import { travelerForgotPassword } from '../../service/travelerLoginService';
import { hasValidationErrors } from '../../lib/airframe/FormValidation';

import { CiriumWrapper } from '../../components/cirium/CiriumWrapper';
import { TravelerForgotCard } from './TravelerForgotCard';
import { TravelerForgotSuccessCard } from './TravelerForgotSuccessCard';
import type { FormErrors, AddToast } from '../../types/airframe';

interface ForgotPasswordValues {
  email: string;
  kwijybo: string;
}

interface ErrorResponse {
  message: string;
}

const TravelerForgotContainer: React.FC = () => {
  const [formDisabled, setFormDisabled] = useState(false);
  const [email, setEmail] = useState<string | undefined>(undefined);
  const [emailNotFound, setEmailNotFound] = useState(false);
  const [loginReset, setLoginReset] = useState(false);

  const travelerForgotPasswordInfo = (values: ForgotPasswordValues) => ({
    email: values.email,
    kwijybo: values.kwijybo,
  });

  const handleForgotPasswordError = (response: ErrorResponse, addToast: AddToast) => {
    setFormDisabled(false);
    if (response.message.includes('Could not find an associated email')) {
      setEmailNotFound(true);
    } else {
      addToast('Forgot login is temporarily unavailable', { variant: 'error' });
    }
  };

  const handleForgotPassword = (errors: FormErrors, values: ForgotPasswordValues, addToast: AddToast) => {
    if (!hasValidationErrors(errors)) {
      const travelerForgotPasswordFormValues = travelerForgotPasswordInfo(values);
      setEmail(travelerForgotPasswordFormValues.email);
      setFormDisabled(true);
      travelerForgotPassword(travelerForgotPasswordFormValues)
        .then(() => {
          setLoginReset(true);
        })
        .catch(error => {
          handleForgotPasswordError(error, addToast);
        })
        .finally(() => {
          setFormDisabled(false);
        });
    }
  };

  return (
    <CiriumWrapper loading={formDisabled}>
      {loginReset && email ? (
        <TravelerForgotSuccessCard email={email} />
      ) : (
        <TravelerForgotCard
          handleForgotPassword={handleForgotPassword}
          loading={formDisabled}
          showError={emailNotFound}
        />
      )}
    </CiriumWrapper>
  );
};

export default TravelerForgotContainer;